import request from '@/utils/request'

export function main () {
  // 获取一级商品列表
  return request({
    url: '/home/getHomePageWeb.action',
    method: 'post'
  })
}
